/*
Fordi enumer ikke kan ligge i en d.ts fil benytter vi her en ordinær ts fil.
*/
import {IPromise} from "angular";
import {EntitetType, LenkerelasjonModell, LitenIkkeTomStreng, SpørsmålOgResultaterModell, SpørsmålOppsett, Spørsmålstype} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

export namespace l {

    /*
     *  Enummer benyttet i modellobjekter i våre ressurser.
     *  Disse er definert her for at de skal være tilgjengelige i js-kode
     */


    export enum Autentiseringsmetode {
        // NB: må holdes i synk med motsvarende enum på serverside.
        passord = 0, totpOtp = 1, smsOtp = 3, criiptoOpenId = 2
    }

    export enum AutentiseringStatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        autentisert = 0, kontostengt = 1, ikkeStøttetMetode = 2, ukjentSubject = 3, ugyldigSpesifikasjon = 4, kreverOppgradering = 5, avbrutt = 6
    }

    export enum CriiptoIdTilbyder {
        // NB: må holdes i synk med motsvarende enum på serverside.
        norsk_bankid_web_og_mobil = 0, svensk_bankid_samedevice = 1, svensk_bankid_anotherdevice = 2, svensk_bankid_anotherdeviceqr = 3
    }

    export enum AkseptertSignaturmetode {
        // NB: må holdes i synk med motsvarende enum på serverside.
        enkelelektronisk = 0, avansertelektronisk = 1
    }

    export enum Signeringsmetode {
        // NB: må holdes i synk med motsvarende enum på serverside.
        lederplan_autentisert_tofakt_sms = 0,
        lederplan_autentisert_tofakt_epost = 7,
        norsk_bankid_netsentrisk_tekst = 1,
        norsk_bankid_netsentrisk_pdf = 3,
        svensk_bankid_samedevice = 4,
        svensk_bankid_anotherdevice = 5,
        svensk_bankid_anotherdeviceqr = 6
    }

    export enum BenyttetSigneringsmetode {
        // NB: må holdes i synk med motsvarende enum på serverside.
        legacy_autentisert = 0,
        legacy_no_bankid_central_pdf = 1,
        lederplan_autentisert_tofakt_sms = 2,
        lederplan_autentisert_tofakt_epost = 13,
        criipto_no_bankid_mobil_tekst = 3,
        criipto_no_bankid_central_tekst = 6,
        criipto_no_bankid_central_pdf = 4,
        criipto_no_bankid_pdf = 11,
        criipto_no_bankid_high_pdf,
        criipto_se_bankid_samedevice = 5,
        criipto_se_bankid_anotherdevice = 7,
        criipto_se_bankid_anotherdevice_qr = 8,
        bankid_qes = 14,
        sp2_bankid = 9,
        sp2_enkel = 10
    }

    export enum Tokenvarighet {
        // NB: må holdes i synk med motsvarende enum på serverside.
        kort = 0, medium = 1, lang = 2
    }

    export enum BenyttetAutentiseringsmetode {
        // NB: må holdes i synk med motsvarende enum på serverside.
        passord = 0, totp = 1, totpReserverkode = 2, sms = 5, bankidNorsk = 3, bankidSvensk = 4
    }

    export enum TilgansrollerBruker {
        // NB: må holdes i synk med motsvarende enum på serverside.
        anonym = 0, ordinaer = 1, administrator = 2, koble_brukere = 3
    }

    export enum TilgangsrolleMedlem {
        // NB: må holdes i synk med motsvarende enum på serverside.
        lese = 0, skrive = 1, tilgangIkkePublisert = 2, tilgangSlettetIHendelseslogg = 3
    }

    export enum Deltakerstatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        innkalling_ikke_sendt = 0, innkalling_sendt = 1, akseptert = 2, avslaatt = 3
    }

    export enum Invitasjonsstatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        ikke_sendt = 0, sendt = 1, akseptert = 2, avslått = 3
    }

    export enum Medlemstatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        normal_tilgang = 0, tilgang_stengt = 1, anonymisert = 2
    }

    export enum VirussjekkStatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        ikke_sjekket = 0, ok = 1, infisert = 2
    }

    export enum Endringstype {
        // NB: må holdes i synk med motsvarende enum på serverside.
        opprett = 0, rediger = 1, slett = 2, innlogging = 3, innlogging_feilet = 4, utlogging = 5, epost = 6, eksport = 7
    }

    export enum SubEndringstype {
        // NB: må holdes i synk med motsvarende enum på serverside.
        flyttTilMøte = 0,
        saksreferatOppdatert = 1,
        møtereferatDetaljerOppdatert = 28,
        dokumentversjon = 2,
        dokumentSignert = 3,
        dokumentKlarTilSignering = 4,
        dokumentSignatarerOppdatert = 26,
        dokumentLåstOpp = 5,
        epostadresseBekreftet = 6,
        mobilnummerBekreftet = 18,
        avstemningsresultatEndret = 7,
        avstemningsresultatNullstilt = 8,
        avstemningAapnet = 9,
        avstemningStengt = 10,
        otpAutentiseringAktivert = 11,
        otpAutentiseringDeaktivert = 12,
        utloggingAlle = 13,
        openIdIdentitetLagtTil = 14,
        openIdIdentitetSlettet = 15,
        skjermingOppdatert = 16,
        publiseringOppdatert = 17,
        møteKopiert = 20,
        sp2Endringshendelse = 22,
        sp2SignEndringshendelse = 23,
        sp2SmsEndringshendelse = 24,
        brukerSlåttSammen = 25,
        medlemAnonymisert = 27
    }

    export enum BeslutningersOppgavestatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        forfalt = 0, ikke_forfalt = 1, utfoert = 2, uten_frist = 3, uten_oppgaver = 4
    }

    export enum OppgavestatusKriterie {
        // NB: må holdes i synk med motsvarende enum på serverside.
        forfalt = 0, ikke_forfalt = 1, utfoert = 2, ikke_utfoert = 4, uten_frist = 3
    }

    export enum Oppgavesorteringskolonne {
        // NB: må holdes i synk med motsvarende enum på serverside.
        frist = 0, tittel = 1, status = 2, bruker = 3
    }

    export enum Oppgavestatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        ikke_påbegynt = 0, påbegynt = 1, utført = 2
    }

    export enum Temastatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        aktiv = 0,
        arkivert = 1,
        overstyrt_til_aktiv = 2,
        overstyrt_til_arkivert = 3
    }

    export enum DokumentType {
        // NB: må holdes i synk med motsvarende enum på serverside.
        generiskDokument = 0,
        opplastetSaksdokument = 1,
        generertAgendaDokument = 2,
        protokolldokumentISak = 3,
        arkivdokumentISak = 4,
        arkivdokument = 5,
        protokolldokument = 6,
        generertForfalteOppgaverDokument = 7,
        generertSpørreundersøkelseResultaterDokument = 8
    }

    export enum ProtokollførtDeltakerstatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        deltatt = 0, forfall = 1, ikkeInnkalt = 2
    }

    export enum SigneringStatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        ikkeAktivert = 0, tilSignering = 1, delvisSignert = 2, signert = 3, signertOgKonvoluttert = 4, eksterntSignert = 5
    }

    export enum SignatarStatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        skalIkkeSignere = 'skalIkkeSignere', skalSignere = 'skalSignere', signert = 'signert'
    }

    export enum Moetesteg {
        // NB: må holdes i synk med motsvarende enum på serverside.
        moetet_er_under_arbeid = 'moetet_er_under_arbeid',
        opprett_saker = 'opprett_saker',
        publiser_moetet = 'publiser_moetet',
        send_innkalling = 'send_innkalling',
        svar_paa_innkalling = 'svar_paa_innkalling',
        du_har_godtatt_innkallingen = 'du_har_godtatt_innkallingen',
        du_har_avslaatt_innkallingen = 'du_har_avslaatt_innkallingen',
        skriv_protokoll = 'skriv_protokoll',
        protokollen_er_under_arbeid = 'protokollen_er_under_arbeid',
        publiser_protokoll = 'publiser_protokoll',
        send_til_signering = 'send_til_signering',
        signer_protokoll = 'signer_protokoll',
        venter_paa_signaturer = 'venter_paa_signaturer',
        du_har_signert_protokollen = 'du_har_signert_protokollen',
        protokoll_ferdig_signert = 'protokoll_ferdig_signert'
    }

    export enum FavorittType {
        // NB: må holdes i synk med motsvarende enum på serverside.
        sak = 'sak', moete = 'moete', dokument = 'dokument', oppgave = 'oppgave', beslutning = 'beslutning'
    }

    export enum InkludertGenerertDokument {
        // NB: må holdes i synk med motsvarende enum på serverside.
        ingen = 0, agenda = 1, protokoll = 2, forfalteOppgaver = 3
    }

    export enum Gruppetype {
        // NB: må holdes i synk med motsvarende enum på serverside.
        ordinær = 0, mal = 1
    }

    export enum SøkEntitetType {
        // NB: må holdes i synk med motsvarende enum på serverside.
        sak = 0, dokument = 1, møte = 2, oppgave = 3, beslutning = 4, kommentar = 5, gruppe = 6, medlem = 7, bruker = 8
    }

    export enum Tekstmarkeringsfarge {
        // NB: må holdes i synk med motsvarende enum på serverside.
        gul = 0, groenn = 1, roed = 2, blaa = 3
    }

    export enum Annoteringstype {
        // NB: må holdes i synk med motsvarende enum på serverside.
        tekstmarkering = 0, rektangelmarkering = 1, ikonmarkering = 2
    }

    export enum Sortering {
        // NB: må holdes i synk med motsvarende enum på serverside.
        stigende = 'stigende', synkende = 'synkende'
    }

    export enum AppPushTokenType {
        // NB: må holdes i synk med motsvarende enum på serverside.
        apn = 0, gcm = 1
    }

    export enum KlientType {
        // NB: må holdes i synk med motsvarende enum på serverside.
        web = 0, app = 1
    }

    export enum Avtalestatus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        prøveperiode = 0, prøveperiodeUtløpt = 1, aktiv = 2, terminert = 3
    }

    export enum KanTermineresStatus {
        IKKE_LASTET_NED = 0,
        NEDLASTING_FOR_GAMMEL = 1,
        OK = 2
    }

    export enum CriiptoGuiModus {
        // NB: må holdes i synk med motsvarende enum på serverside.
        erstatt = 0, popup = 1, cordova = 2
    }

    export enum CriiptoResponsStatus {
        ok = 0, avbrutt_av_bruker = 1, feil = 2
    }

    export enum Meldingstype {
        // NB: må holdes i synk med motsvarende enum på serverside.
        mal = 0,
        loggInnBankId = 1,
        loggInnHoved = 2,
        detteErNyttForMedlem = 3,
        detteErNyttForAdmin = 4,
        detteErNyttForTesting = 5,
        applikasjonHoved = 6,
    }

    export enum Varseltype {
        // NB: må holdes i synk med motsvarende enum på serverside.
        info = 0, advarsel = 1, feil = 2
    }

    export enum Valideringsfeilkode {
        // NB: må holdes i synk med motsvarende enum på serverside.
        generell_nullverdi = 'generell_nullverdi',
        generell_verifisering_feilet = 'generell_verifisering_feilet'
    }

    export enum OpprettMøteValideringsfeil {
        // NB: må holdes i synk med motsvarende enum på serverside.
        protokoll_låst = 'protokoll_låst', møte_opprett_samme_starttidspunkt = 'møte_opprett_samme_starttidspunkt', møte_opprett_ingen_plan = 'møte_opprett_ingen_plan'
    }

    export enum OppdaterMøteValideringsfeil {
        // NB: må holdes i synk med motsvarende enum på serverside.
        protokoll_låst = 'protokoll_låst', møte_opprett_samme_starttidspunkt = 'møte_opprett_samme_starttidspunkt'
    }

    export enum MøtePubliseringValideringsfeil {
        åpent_for_avstemning = 'åpent_for_avstemning', protokoll_låst = 'protokoll_låst'
    }

    export enum MøteProtokollValideringsfeil {
        medlem_skjermet_signere = 'medlem_skjermet_signere'
    }

    export enum SkjermingValideringsfeil {
        ikke_medlem_i_gruppe = 'ikke_medlem_i_gruppe',
        medlem_skal_signere_protokoll = 'medlem_skal_signere_protokoll',
        stenge_egen_tilgang = 'stenge_egen_tilgang',
        fjerne_egen_skjerming = 'fjerne_egen_skjerming',
        medlem_skal_signere_dokument = 'medlem_skal_signere_dokument'
    }

    export enum ImportValideringsfeil {
        maks_dybde_overskredet = 'maks_dybde_overskredet',
        maks_antallfiler_overskredet = 'maks_antallfiler_overskredet'
    }

    export enum SignatarValideringfeil {
        medlem_ikke_satt = 'medlem_ikke_satt',
        dokument_ikke_satt = 'dokument_ikke_satt',
        medlem_skjermet = 'medlem_skjermet',
        medlem_feil_gruppe = 'medlem_feil_gruppe'
    }

    export enum SlåSammenBrukereValideringsfeil {
        brukere_medlem_i_samme_gruppe = 'brukere_medlem_i_samme_gruppe'
    }

    export enum DeaktivertMeldingstype {
        // NB: må holdes i synk med motsvarende enum på serverside.
        forfalteOppgaver = 0,
        sakTildelt = 1,
        oppgaveTildelt = 2
    }

    export enum Møtedokumentdel {
        // NB: må holdes i synk med motsvarende enum på serverside.
        innholdsfortegnelse = 0,
        saksforside = 1,
        AGENDADOC_INCLUDE_DESCRIPTION = 3, //@todo flyttes til agendadok spesifikk valg
        AGENDADOC_INCLUDE_SUGESTED_RESOLUTION = 4  //@todo flyttes til agendadok spesifikk valg
    }

    export enum AgendadokumentDel {
        saksbeskrivelse = 0,
        beslutningsforslag = 1,
        planlagte_deltakere = 2
    }

    export enum OppgaveForelderType {
        gruppe = 0,
        sak = 1,
        beslutning = 2
    }

    export enum SkjemalåsSkjemaId {
        // NB: må holdes i synk med motsvarende enum på serverside.
        moeteprotokoll = 0
    }


    export enum StemmegivningStatus {
        ikkePåbegynt = "ikkePåbegynt", påbegynt = "påbegynt", fullført = "fullført"
    }

    export const enum Aksjeeiertype {
        person = 0, organisasjon = 1,
    }

    /*
     * Interface definisjoner for modellobjekter benyttet i våre ressurser
     * Merk at denne declare module blokken er ren ts-typeinfo som ikke generer noe js-kode.
     */


    /** interface som kun definere de promise-relaterte attributtene til extends ng.resource.IResource<>,
     * de øvrige attributtene benytter vi (og skal vi) ikke, derfor dette subsettet i eget interface */
    export interface AngularRessurs<T> {
        $promise?: IPromise<T>;
        $resolved?: boolean;
    }

    export interface OkRespons extends AngularRessurs<any> {
    }

    //tjenesters datatyper
    export interface EntitetModell<T> extends AngularRessurs<T> {
        id: string;
    }

    export interface SkjermingDetaljerMedValideringsresultatModell<V> extends AngularRessurs<SkjermingDetaljerMedValideringsresultatModell<V>> {
        valideringsresultat: ValideringsresultatModell<V>;
        skjermingsdetaljer: SkjermingDetaljerModell;
    }

    export interface ValideringsresultatModell<V> extends AngularRessurs<ValideringsresultatModell<V>> {
        harFeil: boolean;
        feil: ValideringsfeilModell<V>[]
    }

    export interface ValideringsfeilModell<V> {
        feilkode: V;
        data: { [key: string]: any };
    }

    export interface HarFavoritter {
        favoritter: TynnFavorittModell[];
    }

    export interface SøkSpesifikasjon {
        soekestreng: string;
        periode: DatoPeriode;
        inkluderteEntiteter: SøkEntitetType[];
        inkluderteGrupper: string[];
    }

    export interface SøkEntitetSpesifikasjon {
        sokestreng: string;
        entitetType: SøkEntitetType;
        gruppeId: string;
    }

    export interface SearchResponse extends AngularRessurs<SearchResponse> {
        aggregations: any
        hits: {
            hits: SearchHit[];
            max_score: number;
            total: number;
        };
        timed_out: boolean;
        took: number;
    }

    export interface SearchHit {
        highlight: { [felt: string]: string[] };
        _id: string; //entitetid
        _index: string; //alltid "lederplan"
        _score: number;
        _source: { [felt: string]: any }; //entitet modell, se konkret Adaptere i java-koden
        _type: string; //entitet type; entitet klasse.simpleName(), se EntitetIndeksAdapterBygger
    }

    export interface SøkeresultatModell<T> extends AngularRessurs<SøkeresultatModell<T>> {
        treff: T[];
        totalantall: number;
    }

    export interface LiknendeDokumentModell {
        sak: TynnSakModell;
        dokumentversjon: DokumentVersjonModell;
    }

    export interface FinnSakerOgMalsakerResultatModell extends AngularRessurs<FinnSakerOgMalsakerResultatModell> {
        malsaker: MalsakModell[];
        ordinaereSaker: SakSøkTreffModell[];
    }

    export interface SakSøkTreffModell {
        id: string;
        saksnummer: string;
        tittel: string;
        beskrivelse: string;
        tema: string;
        sakstype: string;
        moetetittel: string;
        moetenummer: string;
        moetedato: Date;
    }

    export interface PlanModell extends EntitetModell<PlanModell> {
        periode: PlanPeriode;
        foersteMoetenummer: number;
        foersteSaksnummer: number;
        moeter: MøteModellEnkel[];
    }

    export interface PlanPeriode {
        start: Date;
        slutt: Date;
    }

    export interface DatoPeriode {
        start: Date;
        slutt: Date;
    }

    export interface EnkelPlanModell extends EntitetModell<EnkelPlanModell> {
        periode: PlanPeriode;
        foersteMoetenummer: number;
        foersteSaksnummer: number;
    }

    export interface PlanMedMøterSpesifikasjon {
        periode: PlanPeriode;
        nyeMoeter: NyttMøteSpesifikasjon[];
        kopierteMoeter: KopierMøteSpesifikasjon[];
    }

    export interface NyttMøteSpesifikasjon {
        id: string;
        gruppeId: string;
        tittel: string;
        dato: MøteDato;
        formaal: string;
        behandlingsSted: string;
        behandlingsMaate: string;
        deltakere: MøtedeltakerSpesifikasjon[];
        deltakereSomSkalSignereProtokoll?: string[];
        eksterneDeltakere: EksternMøtedeltakerSpesifikasjon[];
        valgteMalsaker: string[];
        erMoetePublisert: boolean;
        erProtokollPublisert: boolean;
    }

    export interface MøtedeltakerSpesifikasjon {
        medlemId: string | null;
        medlemInvitasjon: MøtedeltakerGruppeInvitasjonSpesifikasjon | null;
        representerteAksjeeiere: string | null;
    }

    export interface MøtedeltakerGruppeInvitasjonSpesifikasjon {
        navn: string | null;
        epost: string;
        mobilnummer: string | null;
        rolleId: string | null;
    }

    export interface KopierMøteSpesifikasjon {
        id: string;
        kopiAvMoeteId: string;
        gruppeId: string;
        tittel: string;
        dato: MøteDato;
        formaal: string;
        behandlingsSted: string;
        behandlingsMaate: string;
        deltakere: string[];
        deltakereSomSkalSignereProtokoll?: string[];
        eksterneDeltakere: EksternMøtedeltakerSpesifikasjon[];
        valgteSaker: string[];
        erMoetePublisert: boolean;
        erProtokollPublisert: boolean;
    }

    export interface KopierMøteTilGrupperSpesifikasjon {
        startdato: Date;
        gruppeIdr: string[];
    }

    export interface KopierMøteTilGrupperValideringsfeil extends AngularRessurs<KopierMøteTilGrupperValideringsfeil> {
        feil: { [gruppeId: string]: ValideringsresultatModell<OpprettMøteValideringsfeil> };
        harFeil: boolean;
    }

    export interface OppdaterMøteSpesifikasjon {
        id: string;
        dato: MøteDato;
        tittel: string; //håndteres ikke av serversiden..
        formaal: string;
        behandlingsSted: string;
        behandlingsMaate: string;
        deltakere: string[];
        eksterneDeltakere: EksternMøtedeltakerSpesifikasjon[];
    }

    export interface EksternMøtedeltakerSpesifikasjon {
        id: string;
        navn: string;
        rolle: string;
        kommentar: string;
    }

    export interface MøteModell extends EntitetModell<MøteModell>, HarFavoritter {
        id: string;
        nummer: string;
        nummerIPlan: number;
        tittel: string;
        dato: MøteDato;
        planId: string;
        protokollSigneringStatus: SigneringStatus;
        erMoetePublisert: boolean;
        erProtokollPublisert: boolean;
        laastForRedigering: boolean;

        eiendeGruppeId: string;
        behandlingsSted: string;
        behandlingsMaate: string;
        formaal: string;
        protokolldokumentId: string;

        saker: AgendaelementModell[];
        deltakere: MøtedeltakerModell[];
        eksterneDeltakere: EksternMøtedeltakerModell[];
        antallIkkeRepresenterteAksjeeiere: number | null;
        moetevurdering: AggregertMøtevurderingModell;
        appentForStemmegivning: boolean;
        protokollAksepterteSignaturmetoder: AkseptertSignaturmetode[];
        favoritter: TynnFavorittModell[];
        tilgang: TilgangModell;
        detteEllerPaafoelgendeMoeteLaast: boolean;
    }

    export interface MalmøteModell extends EntitetModell<MalmøteModell> {
        eiendeGruppeId: string;
        tittel: string;
        starttidspunkt: string;
        varighet: number;
        behandlingsSted: string;
        behandlingsMaate: string;
        erMoetePublisert: boolean;
        erProtokollPublisert: boolean;
        saker: MalsakModell[];
        deltakere: MalmøteDeltakerModell[];
    }

    export interface MalmøteDeltakerModell {
        medlem: GruppeMedlemListeModell;
        skalSignere: boolean;
    }

    export interface MalsakModell extends EntitetModell<MalsakModell> {
        eiendeGruppeId: string;
        tittel: string;
        beskrivelse: string;
        varighet: number;
        tema: TemaModell;
        sakstype: SakstypeModell;
        ansvarlig: GruppeMedlemListeModell;
        inkludertGenerertDokument: InkludertGenerertDokument;
        beslutningsforslagtittel: string;
        beslutningsforslagbeskrivelse: string;
        erPause: boolean;
        standardIMoete: boolean;
    }

    export interface OppdaterMalmøteSpesifikasjon {
        id: string;
        tittel: string;
        starttidspunkt: string;
        varighet: number;
        behandlingsSted: string;
        behandlingsMaate: string;
        erMoetePublisert: boolean;
        erProtokollPublisert: boolean;
        deltakere: OppdaterMalmøteDeltakerSpesifikasjon[];
        saker: OppdaterMalsakSpesifikasjon[];
    }

    export interface OppdaterMalmøteDeltakerSpesifikasjon {
        medlemId: string;
        skalSignere: boolean;
    }

    export interface OppdaterMalsakSpesifikasjon {
        id: string;
        tittel: string;
        beskrivelse: string;
        varighet: number;
        temaId: string;
        sakstypeId: string;
        ansvarligId: string;
        inkludertGenerertDokument: InkludertGenerertDokument;
        erPause: boolean;
        beslutningsforslagtittel: string;
        beslutningsforslagbeskrivelse: string;
        standardIMoete: boolean;
    }

    export interface MøteModellEnkel extends EntitetModell<MøteModellEnkel> {
        id: string;
        nummer: string;
        nummerIPlan: number;
        tittel: string;
        dato: MøteDato;
        planId: string;
        laastForRedigering: boolean;

        behandlingsSted: string;
        behandlingsMaate: string;
        formaal: string;
        protokolldokumentId: string;
        eiendeGruppeId: string;
        protokollSigneringStatus: SigneringStatus;
        erMoetePublisert: boolean;
        erProtokollPublisert: boolean;
    }

    //@todo erstattes av MøteModellEnkel?
    export interface TynnMøteModell extends AngularRessurs<TynnMøteModell> {
        id: string;
        nummer: string;
        nummerIPlan: number;
        tittel: string;
        dato: MøteDato;
        planId: string;
        laastForRedigering: boolean;
    }

    export interface MøteModellEnkelMedProtokollinfo extends AngularRessurs<MøteModellEnkelMedProtokollinfo> {
        moete: MøteModellEnkel;
        protokolSigneringStatus: SigneringStatus;
        protokollErTilBehandling: boolean;
    }

    export interface MøteDato {
        start: Date;
        slutt: Date;
    }

    export interface MøtedeltakerModell extends EntitetModell<MøtedeltakerModell> {
        medlem: GruppeMedlemListeModell;
        aktiveMedlemsroller: MedlemsRollePeriode2Modell[];
        status: Deltakerstatus;
        sistOppdatert: Date;
        vurdering: number;
        erStemmeberettiget: boolean;
        stemmevekt: number;
        stemmekommentar: string;
        aksjeeierRepresentasjoner: AksjeeierEnkelModell[];
    }

    export interface MøtedeltakereModell extends AngularRessurs<MøtedeltakereModell> {
        deltakere: MøtedeltakerModell[];
    }

    export interface EksternMøtedeltakerModell extends EntitetModell<EksternMøtedeltakerModell> {
        navn: string;
        rolle: string;
        kommentar: string;
        moeteId: string;
        gruppeId: string;
    }

    export interface AvstemningsstatusModell extends AngularRessurs<AvstemningsstatusModell> {
        appentForStemmegivning: boolean;

        antallStemmeberettigedeDeltakere: number;
        antallAvstemninger: number;

        antallStemmerAvgittPerDeltaker: { [møtedeltakerId: string]: number };
        antallDeltakereStemtFerdig: number;
        antallDeltakereStemtDelvis: number;
        antallDeltakereStemtIngen: number;

        antallStemmerAvgittPerAvstemning: { [avstemningId: string]: number };
        antallAvstemningerStemtFerdig: number;
        antallAvstemningerStemtDelvis: number;
        antallAvstemningerStemtIngen: number;
    }

    export interface ÅpneStengeForAvstemningSpesifikasjon {
        informerStemmeberettigede: boolean;
        beskjed: string;
    }

    export interface StemmeberettigetMøtedeltakerSpesifikasjoner {
        deltakere: StemmeberettigetMøtedeltakerSpesifikasjon[];
    }

    export interface StemmeberettigetMøtedeltakerSpesifikasjon {
        deltakerId: string;
        erStemmeberettiget: boolean;
        stemmevekt: number;
        stemmekommentar: string;
    }

    export interface ProtokollDetaljerModell extends AngularRessurs<ProtokollDetaljerModell> {
        dato: MøteDato;
        behandlingsSted: string;
        behandlingsMaate: string;
        behandletISakene: TynnSakModell[];
        erTilBehandling: boolean;
        dokumentVersjon: DokumentVersjonModell;
    }

    export interface ProtokollførtMøtedeltakereModell extends AngularRessurs<ProtokollførtMøtedeltakereModell> {
        moeteId: string;
        deltatte: ProtokollførtMøtedeltakerModell[];
        forfalte: ProtokollførtMøtedeltakerModell[];
        ikkeInnkalte: ProtokollførtMøtedeltakerModell[];
        eksterne: EksternProtokollførtMøtedeltakerModell[];
    }

    export interface ProtokollførtMøtedeltakerModell extends EntitetModell<ProtokollførtMøtedeltakerModell> {
        medlem: GruppeMedlemListeModell;
        aktiveMedlemsroller: MedlemsRollePeriode2Modell[];
        moeteId: string;
        gruppeId: string;
        status: ProtokollførtDeltakerstatus;
        skalSignere: boolean;
        signatar: DokumentSignatarModell | null;
        harSignert: boolean;
        signaturinformasjon: SignaturinformasjonModell;
        kommentar: string;
        aksjeeierRepresentasjoner: AksjeeierIMøteModell[];
    }

    export interface AksjeeierIMøteModell {
        aksjeeierId: string;
        type: Aksjeeiertype;
        navn: string;
        beholdning: number;
        eierandel: number;
    }

    export interface EksternProtokollførtMøtedeltakerModell extends EntitetModell<EksternProtokollførtMøtedeltakerModell> {
        moeteId: string;
        gruppeId: string;
        navn: string;
        rolle: string;
        kommentar: string;
        skalSignere: boolean;
    }

    export interface SignaturinformasjonModell {
        signaturtype: BenyttetSigneringsmetode;
        signertDato: Date;
        signertAv: string;
    }

    export interface AntallMeldingerSendtRespons extends AngularRessurs<AntallMeldingerSendtRespons> {
        antall: number;
    }

    export interface ProtokollSpesifikasjon {
        moeteId: string;
        dato: MøteDato,
        behandlingsMaate: string,
        behandlingsSted: string,
        deltakere: ProtokollførtMøtedeltakerSpesifikasjon[];
        eksterneDeltakere: EksternProtokollførtMøtedeltakerSpesifikasjon[];
        saker: SaksreferatSpesifikasjon[];
    }

    export interface ProtokollførtMøtedeltakerSpesifikasjon {
        medlemId: string;
        status: l.ProtokollførtDeltakerstatus;
        kommentar: string;
        skalSignere: boolean;
    }

    export interface EksternProtokollførtMøtedeltakerSpesifikasjon {
        id: string;
        navn: string;
        rolle: string;
        kommentar: string;
        skalSignere: boolean;
    }

    export interface SaksreferatSpesifikasjon {
        sakId: string;
        referat: string;
        beslutninger: BeslutningsSpesifikasjoner;
    }

    export interface BeslutningsSpesifikasjoner {
        eksisterendeBeslutninger: BeslutningSpesifikasjon[];
        nyeBeslutninger: BeslutningSpesifikasjon[];
    }

    export interface BeslutningSpesifikasjon {
        id: string;
        tittel: string;
        beskrivelse: string;
        slettet: boolean;
        oppgaver: OppgaverSpesifikasjoner;
    }

    export class OppgaverSpesifikasjoner {
        eksisterendeOppgaver: OppgaveSpesifikasjon[];
        nyeOppgaver: OppgaveSpesifikasjon[];
    }

    export class OppgaveSpesifikasjon {
        id: string;
        tittel: string;
        beskrivelse: string;
        frist: Date;
        ansvarligId: string;
        slettet: boolean;
    }

    export interface AggregertMøtevurderingModell {
        antallVurderinger: number;
        gjennomsnittligVurdering: number;
    }

    export interface MøteMedAggregaterModell extends AngularRessurs<MøteMedAggregaterModell> {
        moete: MøteModellEnkel;
        agregater: MøteAggregaterModell;
        kallendeMoetedeltakerModell: KallendeMoetedeltakerModell;
    }

    export interface MøteAggregaterModell {
        antallSaker: number;
        antallSakerMine: number;
        antallInvitert: number;
        antallInvitertAkseptert: number;
        antallInvitertAvslaatt: number;
        antallKommentarer: number;
        antallDokumenter: number;
        antallOppgaver: number;
        antallOppgaverForfalt: number;
    }

    export interface KallendeMoetedeltakerModell {
        brukersDeltakerStatus: Deltakerstatus;
        brukersProtokollsignaturMangler: boolean;
        brukersStemmegivningMangler: boolean;
    }

    export interface MoetestatusModell extends AngularRessurs<MoetestatusModell> {
        muligeSteg: MoetestegModell[];
        aktivtSteg: MoetestegModell;
        moetePublisert: boolean;
        protokollPublisert: boolean;
        /** Signeringsstatus for møtets protokoll, ikkeAktivert indikere at protokoll ikke er sendt til signering, alle øvrige tilstander representerer et låst møte */
        protokollSigneringStatus: SigneringStatus;
        /** Sigeringsstatus for kallende bruker */
        protokollSigneringsstatusForBruker: SignatarStatus;
        /** Deltakerstatus for kallende bruker, empty dersom bruker ikke er invitert til møtet */
        deltakerstatusForBruker?: Deltakerstatus;
    }

    export interface MoetestegModell {
        steg: Moetesteg;
        progresjon: MoetestegProgresjon;
    }

    export interface MoetestegProgresjon {
        totalt: number;
        andel: number;
    }

    export interface AgendaelementModell extends EntitetModell<AgendaelementModell>, HarFavoritter {
        //felles for Sak og Pause
        moete: TynnMøteModell;
        eiendeGruppeId: string;
        tittel: string;
        beskrivelse: string;
        starttidspunkt: Date;
        dag: number;
        varighet: number;
        erPause: boolean;
        tilgang: TilgangModell;

        indeks: number;

        //spesifikt for Sak
        nummer: string;
        nummerIMoete: number;
        referat: string;
        tema: TemaModell;
        sakstype: SakstypeModell;
        kommentarer: KommentarModell[];
        beslutninger: BeslutningModell[];
        avstemninger: AvstemningMedResultatModell[];
        oppgaver: OppgaveModell[];
        dokumenter: SaksdokumentModell[];
        ansvarlig: GruppeMedlemListeModell;
        sp2Ansvarlig: string;
        referertFra: LenkerelasjonModell[];
    }

    export interface OpprettSakSpesifikasjon {
        id: string;
        moeteId: string;
        tittel: string;
        beskrivelse: string;
        temaId: string;
        sakstypeId: string;
        dag?: number; //kun ved flerdagsmøte
        startklokkeslett?: string; //kun ved flerdagsmøte
        varighet: number;
        ansvarligId: string;
        erPause: boolean;
        kopierFraMalsakId: string;
        kopierFraSakId: string;
    }

    export interface OppdaterSakSpesifikasjon {
        id: string; //sakid - merk at denne ikke er def i javamodellen
        moeteId: string;
        tittel: string;
        beskrivelse: string;
        temaId: string;
        sakstypeId: string;
        dag?: number; //kun ved flerdagsmøte
        startklokkeslett?: string; //kun ved flerdagsmøte
        varighet: number;
        ansvarligId: string;
    }

    export interface OppdaterPauseSpesifikasjon {
        id: string; //sakid - merk at denne ikke er def i javamodellen
        tittel: string;
        beskrivelse: string;
        dag?: number; //kun ved flerdagsmøte
        startklokkeslett?: string; //kun ved flerdagsmøte
        varighet: number;
    }

    export interface SendInnkallingSpesifikasjon {
        mottakere: string[];
        beskjed: string;
        inkluderAgenda: boolean;
        huskInkluderAgendaValg: boolean;
        publiserMoete: boolean;
    }

    export interface SendProtokollsigneringsInvitasjonSpesifikasjon {
        beskjed: string;
        signaturmetoder: AkseptertSignaturmetode[];
        huskSignaturmetodeValg: boolean;
    }

    export interface GenerellEpostTilMedlemmerSpesifikasjon {
        beskjed: string;
        mottakere: string[]; //medlemIder
    }

    export interface MøtepubliseringSpesifikasjon {
        erPublisert: boolean;

        //følgende er kun angitt dersom erPublisert=true
        sendMelding?: boolean;
        beskjed?: string;
        mottakere?: string[];
    }

    export interface MøtedokumentvalgModell extends AngularRessurs<MøtedokumentvalgModell> {
        utelatteSaker: string[]; //saksider
        utelatteSaksdokumenter: string[]; //dokumentider
        genereMoetedokumentTosidig: boolean;
        utelatteMoetedokumentdeler: Møtedokumentdel[];
    }

    export interface OppdaterMøtedokumentvalgSpesifikasjon {
        utelatteSaker: string[]; //saksider
        utelatteSaksdokumenter: string[]; //dokumentider

        settSomStandardForGruppe: boolean;
        genereMoetedokumentTosidig: boolean;
        utelatteMoetedokumentdeler: Møtedokumentdel[];
    }

    export interface BrukersSaksstatistikk {
        kommende: number;
        tidligere: number;
    }

    export interface GruppertTynnSakModell {
        kommende: TynnSakModell[];
        tidligere: TynnSakModell[];
    }

    export interface TynnSakModell extends EntitetModell<TynnSakModell> {
        nummer: string;
        tittel: string;
        sakstype: string;
        moete: TynnMøteModell;
        gruppe: EnkelGruppeModell;
    }

    export interface KommentarModell extends EntitetModell<KommentarModell> {
        kommentar: string;
        privat: boolean;
        publisertAv: GruppeMedlemListeModell;
        publisertDato: Date;
        gruppeId: string;
        forelder: ForelderModell;
        varslede: GruppeMedlemListeModell[];
        svar: SvarModell[];
        senesteSvar: SvarModell;
        senestePubliseringsdato: Date;
    }

    export interface OpprettKommentarSpesifikasjon {
        id: string;
        kommentar: string;
        varslede: string[];
        privat: boolean;
    }

    export interface ForelderModell {
        harForelder: boolean;
        entitetRef: EntitetReferanseModell;
        beskrivelse: StrengMal<any>;
    }

    export interface SvarModell extends EntitetModell<SvarModell> {
        svar: string;
        publisertDato: Date;
        publisertAv: GruppeMedlemListeModell;
    }

    export interface DokumentVersjonBasisModell<T> extends EntitetModell<T>, HarFavoritter {
        type: DokumentType;
        dokumentId: string;
        gruppeId: string;
        harPdfRepresentasjon: boolean;
        forsideBildeId: string;
        antallSider: number;
        filnavn: string;
        pdfFilnavn: string;
        filstoerrelse: number;
        pdfFilstoerrelse: number;
        orginalformat: string;
        versjonsnummer: number;
        virussjekkStatus: VirussjekkStatus;
        antallAnnotasjoner: number;
        signeringStatus: SigneringStatus;
        aksepterteSignaturmetoder: AkseptertSignaturmetode[];
        erLestAv: boolean | null;
        foreldre: DokumentVersjonForelderModell;
        skjerming: SkjermingModell;
        googleDriveUrl: string;
        microsoftOneDriveUrl: string;
        registrertAv?: EnkelGruppeMedlemModell;
        registreringsdato: Date
    }

    export interface DokumentVersjonForelderModell {
        sakId: string | null;
        protokolldokumentId: string | null;
        arkivdokumentId: string | null;
        arkivfilnodeId: string | null;
    }

    export interface DokumentVersjonModell extends DokumentVersjonBasisModell<DokumentVersjonModell> {
    }

    export interface SaksdokumentModell extends DokumentVersjonBasisModell<SaksdokumentModell> {
        /** @deprecated*/ sakId: string;
        /** @deprecated*/ gjeldendeVersjonId: string; //bruk versjonId
        /** @deprecated*/ dataId: string;
        /** @deprecated*/ pdfDataId: string;
        /** @deprecated*/ forelderRef: EntitetReferanseModell;
        indeks: number;
    }

    export interface ProtokolldokumentISakModell extends SaksdokumentModell {
        sakerProtokollBehandlesI: TynnSakModell[];
        protokollForMoete: TynnMøteModell;
    }

    export interface DokumentDataModell extends EntitetModell<DokumentDataModell> {
        dataId: string;
        pdfDataId: string;
        filnavn: string;
        originalformat: string;
        pdfFilnavn: string;
        progresjon?: { total: number; naa: number }
    }

    /** Areal - rektangel definert i PDF koordinater */
    export interface PdfRektangel {
        tlx: number;
        tly: number;
        brx: number;
        bry: number;
    }

    export interface DokumentAnnoteringModell {
        id: string;
        gruppeId: string;
        registrertDato: Date;
        registrertAv: GruppeMedlemListeModell;
        sidenummer: number;
        type: Annoteringstype;
        visualisering: { farge: Tekstmarkeringsfarge; markertOmraade: PdfRektangel | PdfRektangel[] };
        markertTekst?: string;
        kommentarer: KommentarModell[];
    }

    export interface DokumentSignatarerModell extends AngularRessurs<DokumentSignatarerModell> {
        signeringsInvitasjonSendt: Date;
        dagerTilNestePurring: number;
        nestePurringSendes: Date;
        signatarer: DokumentSignatarModell[];
    }

    export interface DokumentSignatarModell extends EntitetModell<DokumentSignatarModell> {
        harSignert: boolean;
        signaturinformasjon: SignaturinformasjonModell | null;
        medlem: GruppeMedlemListeModell;
    }

    export interface PotensiellDokumentSignatarModell extends AngularRessurs<PotensiellDokumentSignatarModell> {
        signatarFunnet: boolean;
        antattStoettedeSigneringsmetoder: Signeringsmetode[];
        signatar: DokumentSignatarModell | null;
    }

    export interface SendTilSigneringSpesifikasjon {
        signaturmetoder: AkseptertSignaturmetode[];
        huskSignaturmetodeValg: boolean;
        signatarer: string[];
        beskjed: string;
    }

    export interface OppdaterSignatarerSpesifikasjon {
        signaturmetoder: AkseptertSignaturmetode[];
        huskSignaturmetodeValg: boolean;
        signatarer: string[];
        beskjed: string;
        aarsak: string;
    }

    export interface DokumenterTilSigneringModell extends AngularRessurs<DokumenterTilSigneringModell> {
        arkivdokumenter: DokumentTilSigneringModell<DokumentVersjonModell>[];
        saksdokumenter: DokumentTilSigneringModell<DokumentVersjonModell>[];
        moeter: DokumentTilSigneringModell<MøteModellEnkel>[];
    }

    export interface DokumentTilSigneringModell<T> {
        tilSignering: T;
        signatarer: DokumentSignatarerModell;
    }

    export interface ÅrshjulInnslagModell extends EntitetModell<ÅrshjulInnslagModell> {
        tittel: string;
        beskrivelse: string;
        startuke: number;
        antallUker: number;
        harForelder: boolean;
        gruppeId: string;
    }

    export interface ÅrshjulInnslagSpesifikasjon {
        id: string;
        tittel: string;
        beskrivelse: string;
        startuke: number;
        antallUker: number;
    }

    export interface TemaModell extends EntitetModell<TemaModell> {
        navn: string;
        beskrivelse: string;
        indeks: number;
        arkivert: boolean;
        harForelder: boolean;
        kanIkkeSlettes: boolean;
    }

    export interface TemaSpesifikasjon {
        id: string;
        navn: string;
        beskrivelse: string;
        arkivert: boolean;
    }

    export interface SakstypeModell extends EntitetModell<SakstypeModell> {
        navn: string;
        indeks: number;
        kanIkkeSlettes: boolean;
    }

    export interface SakstypeSpesifikasjon {
        id: string;
        navn: string;
    }

    export interface BeslutningModell extends EntitetModell<BeslutningModell>, HarFavoritter {
        eiendeGruppeId: string
        sakId: string;
        sakstittel: string;
        moetetittel: string;
        tittel: string;
        tittelForslag: string;
        beskrivelse: string
        beskrivelseForslag: string
        erForslag: boolean;
        oppgaver: OppgaveModell[];
        favoritter: TynnFavorittModell[];
        referertFra: LenkerelasjonModell[];
        laastForRedigering: boolean;
    }

    export interface BeslutningMedMøteModell extends EntitetModell<BeslutningMedMøteModell> {
        tittel: string;
        beskrivelse: string;
        erForslag: boolean;
        oppgaver: OppgaveModell[];
        eiendeGruppeId: string;
        moeteId: string;
        moeteDatoStart: Date;
        moetenummer: string;
        moetetittel: string;
        sakId: string;
        saksnummer: string;
        sakstittel: string;
    }

    export interface BeslutningGruppeAggregatModell {
        antallPerGruppe: { [index: string]: number };
    }

    export interface BeslutningPerMøtedatoAggregatModell {
        totalAntall: number;
        antallPerMoeteDato: { [index: string]: number };
    }

    export interface BeslutningAggreatModell extends AngularRessurs<BeslutningAggreatModell> {
        gruppe: BeslutningGruppeAggregatModell;
        moetedato: BeslutningPerMøtedatoAggregatModell;
    }

    export interface MøterMedBeslutningerModell {
        moeter: MøtesSakerMedBeslutningerModell[];
        ikkeFlerMoeter: boolean;
    }

    export interface MøtesSakerMedBeslutningerModell extends EntitetModell<MøtesSakerMedBeslutningerModell> {
        id;
        dato: MøteDato;
        nummer: string;
        moetenavn: string;

        gruppenavn: string;
        organisasjonsnavn: string;

        saker: SaksBeslutningerModell[];
    }

    export interface SaksBeslutningerModell extends EntitetModell<TynnBeslutningModell> {
        id;
        tittel;
        nummer;
        beslutninger: TynnBeslutningModell[];
    }

    export interface TynnBeslutningModell extends EntitetModell<TynnBeslutningModell> {
        id;
        tittel: string;
        erForslag: boolean;
        antallOppgaver: number;
        antallOppgaverUtfort: number;
    }

    export interface FinnBeslutningerSpesifikasjon {
        grupper: string[];
        oppgavestatuser: number[];
    }

    export interface OppdaterBeslutningOgOppgaverSpesifikasjon {
        id: string;
        sakId: string;
        tittel: string;
        beskrivelse: string;
        erForslag: boolean;
        oppgaver?: MuterendeOppgaveSpesifikasjon[];
    }

    export interface MuterendeOppgaveSpesifikasjon {
        id: string;
        tittel: string;
        frist: Date;
        beskrivelse: string;
        ansvarligId: string;
        status?: Oppgavestatus;
        utfoertDato?: Date;
    }

    export interface OppgaveStatusSpesifikasjon {
        id: string;
        status: l.Oppgavestatus;
        utfoertDato?: Date;
    }

    export interface AvstemningMedResultatModell extends EntitetModell<AvstemningMedResultatModell> {
        eiendeGruppeId: string
        sakId: string;
        tittel: string;
        beskrivelse: string;

        erAapenForAvstemning: boolean;
        deltakerErStemmeberettiget: boolean;
        avstemningsalternativer: AvstemningsalternativMedResultatModell[];
    }

    export interface AvstemningMedMøteModell extends AngularRessurs<AvstemningMedMøteModell> {
        avstemning: AvstemningMedResultatModell;

        moeteId: string;
        moetenummer: string;
        moetetittel: string;
        moeteDatoStart: Date;
        sakId: string;
        saksnummer: string;
        sakstittel: string;
    }

    export interface AvstemningsalternativModell {
        id: string;
        tittel: string;
    }

    export interface AvstemningsalternativMedResultatModell {
        id: string;
        tittel: string;
        erDeltakersValg: boolean;
        //følgende felt blir kun populert dersom avstemning stengt eller bruker har skrivetilgang
        antallStemmer: number;
        erVinner: boolean;
    }

    export interface ManglerStemmegivningModell {
        moete: MøteModellEnkel;
        antallAvstemninger: number;
        stemmegivere: StemmegivningInfoModell[];
    }

    export interface StemmegivningInfoModell {
        medlem: GruppeMedlemListeModell;
        status: StemmegivningStatus;
    }

    export interface OpprettAvstemningSpesifikasjon {
        id: string;
        sakId: string;
        tittel: string;
        beskrivelse: string;
        alternativer: AvstemningsalternativSpesifikasjon[];
    }

    export interface OppdaterAvstemningSpesifikasjon {
        id?: string; //ikke med i server APIet - men brukes i api-kall urlen
        tittel: string;
        beskrivelse: string;
        alternativer: AvstemningsalternativSpesifikasjon[];
    }

    export class AvstemningsalternativSpesifikasjon {
        id: string;
        tittel: string;
    }

    export interface AggregerteOppgaverModell extends AngularRessurs<any> {
        bruker: AggregertOppgaveInfoModell;
        alle: AggregertOppgaveInfoModell;
    }

    export interface AntallOppgaverPerBrukerModell {
        bruker: EnkelBrukerModell | null;
        antallIkkeUtfoerte: number;
        antallForfalte: number;
    }

    export interface AggregertOppgaveInfoModell {
        forfalte: number;
        utforte: number;
        totalt: number;
    }

    export interface AntallForfalteOppgaver {
        antallForfalteOppgaver: number;
    }

    export interface OppgaverMedPaginering extends AngularRessurs<OppgaverMedPaginering> {
        oppgaver: OppgaveModell[];
        antallOppgaver: number;
    }

    export interface OppgaveModell extends EntitetModell<OppgaveModell>, HarFavoritter {
        eiendeGruppeId: string;
        tittel: string;
        frist: Date;
        utfoertDato: Date;
        utfoert: boolean;
        status: Oppgavestatus;
        beskrivelse: string;
        // ansvarlig vil kun være null på migrerte oppgaver. Disse vil alltid være knyttet til en beslutning.
        ansvarlig: GruppeMedlemListeModell;
        sp2Ansvarlig: string;
        kommentarer: KommentarModell[];
        harForelder: boolean;
        forelderRef: EntitetReferanseModell;
        forelderBeskrivelse: StrengMal<any>;
        referertFra: LenkerelasjonModell[];
    }

    export interface FinnOppgaverSpesifikasjon {
        /** gruppeIder */
        grupper: string[];
        statuser: OppgavestatusKriterie[];
        /** medlemIder */
        ansvarlige: string[];

        sortering?: OppgaveSorteringsspesifikasjon;
        paginering?: OppgavePagineringSpesifikasjon;
    }

    export interface OppgaveAggreatModell extends AngularRessurs<OppgaveAggreatModell> {
        gruppe: GruppeAggregatModell;
        ansvarlig: AnsvarligAggregatModell;
        frist: FristAggregatModell;
        status: StatusAggregatModell;
    }

    export interface GruppeAggregatModell {
        totalAntall: number;
        antallPerGruppe: { [index: string]: number };
    }

    export interface AnsvarligAggregatModell {
        totalAntall: number;
        antallPerMedlem: { [index: string]: number };
    }

    export interface FristAggregatModell {
        totalAntall: number;
        antallIkkeUtført: number;
        antallPerPerFristDato: { [index: string]: number };
    }

    export interface StatusAggregatModell {
        totalAntall: number;
        antallUtenFrist: number;
        antallForfalt: number;
        antallUtført: number;
        antallIkkeForfalt: number;
    }

    export interface OppgaveSorteringsspesifikasjon {
        kolonne: l.Oppgavesorteringskolonne;
        retning: l.Sortering;
    }

    export interface OppgavePagineringSpesifikasjon {
        offsett: number;
        maksAntall: number;
    }

    export interface Pagineringsoffsett {
        offsett: number;
    }

    export interface EntitetReferanseModell {
        id: string;
        type: EntitetType; //må bruker ng2 type (var streng i ajs, er streng-enum i ng2)
    }

    export interface EntitetReferanseSpesifikasjon {
        id: string;
        type: EntitetType;
    }

    export interface StrengMal<T> {
        noeklerOgVerdier: T; //map med nøkkel->verdi
        malnavn: string;
    }

    export interface EnkelBrukerModell extends EntitetModell<EnkelBrukerModell> {
        brukernavn: string;
        epost: string;
        epostErBekreftet: boolean;
        navn: string;
        navnEllerEpost: string;
        mobilnummer: string;
        mobilnummerErBekreftet: boolean;
        spraak: string;
        tidssone: string;
        avatarId: string;
    }

    export interface BrukerModell extends EntitetModell<BrukerModell> {
        brukernavn: string;
        epost: string;
        epostErBekreftet: boolean;
        mobilnummerErBekreftet: boolean;
        navn: string;
        navnEllerEpost: string;
        mobilnummer: string;
        tilgangsroller: TilgansrollerBruker[];
        autentiseringsmetoder: Autentiseringsmetode[];
        openIdAutentiseringsmetoder: BenyttetAutentiseringsmetode[];
        avatarId: string;
        spraak: string;
        tidssone: string;
        deaktiverteMeldingstyper: DeaktivertMeldingstype[];
    }

    export interface TokeninformasjonModell extends EntitetModell<TokeninformasjonModell> {
        utstedelsestidspunkt: Date;
        utloepstidspunkt: Date;
        ipLokasjon: IpLokasjon;
        userAgent: string;
        klientType: KlientType;
        autentiseringmetode: BenyttetAutentiseringsmetode;
    }

    export interface IpLokasjon {
        ip: string;
        kontinent: string;
        land: string;
        region: string;
        by: string;
    }

    export interface FavorittModell extends EntitetModell<FavorittModell> {
        id: string;
        type: FavorittType;
        gruppeId: string;
        opprettetDato: Date;
        assosiertEntitet: EntitetReferanseModell;
        assosiertEntitetBeskrivelse: any; //se de ulike entitets spesifikk modellene i FavorittRessurs.java
    }

    export interface TynnFavorittModell extends EntitetModell<TynnFavorittModell> {
        id: string;
        brukerId: string;
        opprettetDato: Date;
    }

    export interface OppdaterBrukerSpesifikasjon {
        id: string;
        navn: string;
        avatarBase64: string;
    }

    export interface MeldingsinnstillingerSpesifikasjon {
        deaktiverteMeldingstyper: l.DeaktivertMeldingstype[];
    }

    export interface SlåSammenBrukereSpesifikasjon {
        beholdesId: string;
        slettesId: string;
    }

    export interface OppdatertSensitiveDataModell extends AngularRessurs<OppdatertSensitiveDataModell> {
        autentiseringOk: boolean
        mobilnummerKreverValidering: boolean;
        brukerModell: BrukerModell;
    }

    export interface OppdaterBrukerSensitivSpesifikasjon {
        id: string;
        mobilnummer: string;
        epost: string;
        brukernavn: string;
        autentiseringsinfo: Reautentiseringsinformasjon;
    }

    export interface Reautentiseringsinformasjon {
        metode: l.BenyttetAutentiseringsmetode;

        //dersom metode er passord
        passord?: string;

        /**
         * Angis dersom metode = bankidNorsk/bankidSvensk
         */
        eid?: EidInformasjon;
    }

    export interface EidInformasjon {
        autentiseringskode: LitenIkkeTomStreng;
        guiModus: CriiptoGuiModus;
        tilbyder: CriiptoIdTilbyder;
    }

    export interface EpostModell {
        brukerId: string;
        epost: string;
    }

    export interface EpostValideringsresultat extends AngularRessurs<EpostValideringsresultat> {
        feilkoder: string[]
    }

    export interface GodtaInvitasjonTilNyBrukerSpesifikasjon {
        brukernavnOgEpost: string;
        passord: string;
        engangskode: string;
        token: string;
        spraak: string;
        tidssone: string;
    }

    export interface GodtaInvitasjonTilNyBrukerFraOpenidSubjectSpesifikasjon {
        criiptoSpesifikasjon: CriiptoBindBrukerSpesifikasjon;
        brukernavnOgEpost: string;
        spraak: string;
        tidssone: string;
        invitasjonstoken: string;
        engangskode: string;
    }

    export interface NyAvtaleOgGruppeSpesifikasjon {
        avtale: NyAvtalepesifikasjon;
        gruppe: NyGruppeSpesifikasjon;
    }

    export interface NyGruppeSpesifikasjon {
        avtale?: string; //avtaleId
        gruppenavn: string;
        organisasjonsnavn: string;
        moetenavn: string;
        farge?: string | null;
        logoBase64?: string | null;
        spraak: string;
        tidssone: string;
        mal: string;
    }

    export interface TillatteAutentiseringsmetoderSpesifikasjon {
        metoder: Autentiseringsmetode[];
        autentiseringsinfo: Reautentiseringsinformasjon;
    }

    export interface NyAvtalepesifikasjon {
        navn: string;
        lisensAkseptert: boolean;
        aksepterteBetingelser: string;
    }

    export interface NyBrukerSpesifikasjon {
        epost: string;
        passord: string;
        navn: string;
        spraak: string;
        tidssone: string;
    }

    export interface NyBrukerOgAvtaleOgGruppeSpesifikasjon {
        bruker: NyBrukerSpesifikasjon;
        avtale: NyAvtalepesifikasjon;
        gruppe: NyGruppeSpesifikasjon;
    }

    export interface InnloggingsSpesifikasjon {
        brukernavn: string;
        passord: string;
        totpOtpKode?: string;
        smsOtpKode?: string;
        tokenvarighet?: Tokenvarighet;
        forespurtMetode?: Autentiseringsmetode;
    }

    export interface TotpReservekodeInnloggingsSpesifikasjon {
        brukernavn: string;
        passord: string;
        totpReservekode: string;
    }

    export interface SmsOtpReservekodeInnloggingsSpesifikasjon {
        brukernavn: string;
        passord: string;
        smsOtpReservekode: string;
    }

    export interface CriiptoTokenInnloggingsSpesifikasjon {
        kode: string;
        tokenvarighet: Tokenvarighet;
        guiModus: l.CriiptoGuiModus;
        tilbyder: l.CriiptoIdTilbyder;
        styreplanLoginAktivert: boolean;
    }

    export interface CriiptoBindBrukerSpesifikasjon {
        kryptertOpenIdIdentitet: string;
        tokenvarighet: Tokenvarighet;
    }

    export interface CriiptoBindFraTokenSpesifikasjon {
        kryptertOpenIdIdentitet: string;
        tokenvarighet: Tokenvarighet;
        epost: string;
        token: string;
    }

    /** data mottatt fra criipto via callback */
    export interface CriiptoCallbackParams {
        code: string;
        state: string;
        /** ikke-tom streng dersom bruker avbrøt bankid dialogen eller annen feil oppstod */
        error: string;
    }

    /** data sendt med i melding som sendes fra bankid-iframe til forelder vhja window.parent.postMessage(CriiptoAutentisertMelding).
     * Se lederplan-tjenester/src/main/resources/no/systemfabrikken/lederplan/tjenester/criipto/criiptoSignertRespons.html */
    export interface CriiptoAutentisertMelding extends CriiptoCallbackParams {
        type: 'criiptoAutentisert';
    }

    /** data sendt med i melding som sendes fra criipto-iframe til forelder vhja window.parent.postMessage(CriiptoSignertMelding).
     * Se lederplan-tjenester/src/main/resources/no/systemfabrikken/lederplan/tjenester/criipto/criiptoSignertRespons.html */
    export interface CriiptoSignertMelding {
        type: 'criiptoSignert';
        href: string;
        status: CriiptoResponsStatus,
        error: string
    }

    export interface DeaktiverOpenIdBindingSpesifikasjon {
        metode: BenyttetAutentiseringsmetode;
        autentiseringsinfo: Reautentiseringsinformasjon;
    }

    export interface DeaktivertOpenIdBindingModell extends AngularRessurs<DeaktivertOpenIdBindingModell> {
        autentiseringOk: boolean;
    }

    export interface AvtaledetaljerModell extends EntitetModell<AvtaledetaljerModell> {
        navn: string;
        kontaktperson: EnkelBrukerModell;
        aksepterteBetingelser: string;
        opprettetDato: Date;
        proeveperiodeUtloepsdato: Date;
        slettesDato: Date;
        avtalestatus: Avtalestatus;
        laastForRedigering: boolean;
        faktureringsinformasjonAngitt: boolean;
        faktureringsinformasjon: FaktureringsinformasjonModell;
        aktiveBrukere: EnkelBrukerModell[];
        grupper: GruppeModell[];
        nedlastningsTidspunkt: string | null;
    }

    export interface AvtaleModell extends EntitetModell<AvtaleModell> {
        navn: string;
        kontaktperson: EnkelBrukerModell;
        opprettetDato: Date;
        proeveperiodeUtloepsdato: Date;
        slettesDato: Date;
        avtalestatus: Avtalestatus;
        faktureringsinformasjonAngitt: boolean;
        antallBrukere: number;
        grupper: l.EnkelGruppeModell[];
        antallGrupper: number;
        nedlastningsTidspunkt: string | null;
    }

    export interface KanAvtaleTermineresInfoModell extends AngularRessurs<KanAvtaleTermineresInfoModell> {
        grupper: EnkelGruppeModell
        eksportGjennomfoert: boolean;
        senesteDataeksportHendelser: EndringshendelseModell[];
        antallDagerFoerSletting: number;
        beregnetSlettedato: Date;
    }

    export interface KanAvtaleTermineresInfoModell2 {
        status: KanTermineresStatus;
        antallDagerFoerSletting: number;
        beregnetSlettedato: Date;
        nedlastningMaaVaereNyereEnn: Date;
        maaAvsluttesFoer: Date | null;
    }


    export interface TerminerAvtalepesifikasjon {
        id: string;
        avtalenavn: string;
        verifiserEksportert: boolean;
    }

    export interface TerminerAvtaleResponsModell {
        avtale: AvtaleModell;
        feilKode: boolean;
        terminert: boolean;
        ikkeLastetNed: boolean;
        forGammelNedlastning: boolean;
    }

    export interface PrøveperiodeUtløpsdatoSpesifikasjon {
        id: string;
        proeveperiodeUtloepsdato: Date;
    }

    export interface FaktureringsinformasjonModell {
        adresseLinje1: string;
        adresseLinje2: string;
        postnummer: string;
        poststed: string;
        landkode: string;
        epostadresse: string;
        organisasjonsnummer: string;
    }

    export interface TynnAvtalemodell extends EntitetModell<TynnAvtalemodell> {
        navn: string;
    }

    export interface RedigerAvtalepesifikasjon {
        id: string;
        navn: string;
        kontaktperson: string;
    }

    export interface RedigerFakturainformasjonSpesifikasjon {
        avtaleId: string;
        adresseLinje1: string;
        adresseLinje2: string;
        postnummer: string;
        poststed: string;
        landkode: string;
        epostadresse: string;
    }

    export interface BrregEnhet extends AngularRessurs<BrregEnhet> {
        organisasjonsnummer: string;
        navn: string;
        forretningsadresse: BrregAdresse;
        postadresse: BrregAdresse;
    }

    export interface BrregAdresse {
        land: string;
        landkode: string;
        postnummer: string;
        poststed: string;
        adresse: string[];
        kommune: string;
        kommunenummer: string;
    }

    export interface BetingelserModell extends AngularRessurs<BetingelserModell> {
        betingelser: string;
    }

    export interface GruppeModell extends EntitetModell<GruppeModell> {
        tittel: string;
        organisasjonsnavn: string;
        avtaleId: string;
        aksjeeierbokId: string | null;
        harAksjeeierbok: boolean;
        moetenavn: string;
        logoId: string;
        nedlastningsTidspunkt: string | null;
        oppsett: OppsettModell;
        gruppetype: Gruppetype;
        gruppemal: GruppemalModell | null;
        foreldergruppenavn: string | null;
        /** @deprecated */ medlemmer: GruppeMedlemListeModell[];
        /** @deprecated */ inaktiveMedlemmer: GruppeMedlemListeModell[];
        /** @deprecated */ invitasjoner: GruppeInvitasjonModell[];
        alleMedlemmer: GruppeMedlemListeModell[];
        antallMoeterInnevaerendeAar: number;
        tillatteAutentiseringsmetoder: Autentiseringsmetode[];
        farge: string;
    }

    export interface EnkelGruppeModell extends EntitetModell<EnkelGruppeModell> {
        tittel: string;
        organisasjonsnavn: string;
        moetenavn: string;
        gruppemal?: GruppemalModell;
        oppsett: OppsettModell;
        farge: string;
        gruppetype: Gruppetype;
        avtaleId: string;
        logoId: string;
        nedlastningsTidspunkt: string | null;
    }

    export type EnkelEllerGruppeModellEller = EnkelGruppeModell | GruppeModell;

    export interface TillatteAutentiseringsmetoderOppdatertModell extends AngularRessurs<TillatteAutentiseringsmetoderOppdatertModell> {
        autentiseringOk: boolean;
        tillatteAutentiseringsmetoder: Autentiseringsmetode[];
    }

    export interface GruppemalModell {
        navn: string;
        beskrivelse: string;
    }

    export interface OppsettModell extends AngularRessurs<OppsettModell> {
        moeteOgSaksNummerFormat: MøteOgSaksNummerFormatModell;
        inkluderAgendaIInnkalling: boolean;
        aksepterteSignaturmetoder: AkseptertSignaturmetode[];
        skjulSensitivInformasjonIMeldinger: boolean;
        genereMoetedokumentTosidig: boolean;
        utelatteMoetedokumentdeler: l.Møtedokumentdel[];
        agendaDokumentValg: l.AgendaDokumentValgModell;
        forfalteOppgaverDokumentValg: l.ForfalteOppgaverDokumentValg;
        protokollValg: l.ProtokollValgModell;
        moetevurderingAktivert: boolean;
        sorterSakerEtterSakstype: boolean;
        spraak: string;
        tidssone: string;
    }

    export interface AgendaDokumentValgSpesifikasjon {
        utelatteDeler: AgendadokumentDel[]
    }

    export interface AgendaDokumentValgModell {
        utelatteDeler: AgendadokumentDel[]
    }

    export interface ForfalteOppgaverDokumentSpesifikasjon {
        utelatteForelderTyper: OppgaveForelderType[]
    }

    export interface ForfalteOppgaverDokumentValg {
        utelatteForelderTyper: OppgaveForelderType[]
    }

    export interface ProtokollValgModell {
        beslutningOrdlydEntall: string;
        beslutningOrdlydFlertall: string;
    }

    export interface MøteOgSaksNummerFormatModell {
        moetenummerformat: string;
        saksnummerformat: string;
    }

    export interface AdminEnkelGruppeModell extends EnkelGruppeModell {
        opprettendeBruker: EnkelBrukerModell;
        opprettelsesTidspunkt: Date;
        avtalenavn: string;
    }

    export interface UtvidetGruppeInvitasjonModell extends AngularRessurs<UtvidetGruppeInvitasjonModell> {
        invitasjon: GruppeInvitasjonModell;
        gruppe: EnkelGruppeModell;
    }

    export interface GruppeInvitasjonStatusModell extends AngularRessurs<GruppeInvitasjonStatusModell> {
        erGyldig: boolean,
        harBruker: boolean,
        invitasjon: GruppeInvitasjonTilGodkjenningModell
    }

    export interface GruppeInvitasjonTilGodkjenningModell extends EntitetModell<GruppeInvitasjonTilGodkjenningModell> {
        token: string;
        epost: string;
        navnEllerEpost: string;
        rolle: MedlemsRolleModell;
        opprettetDato: Date;
        gruppeTittel: string;
        gruppeOrganisasjonsnavn: string;
        kreverOtpGodkjenning: boolean;
        kreverEid: boolean;
        otpValidert: boolean;
    }

    export interface InvitasjonOtpSendtModell extends AngularRessurs<InvitasjonOtpSendtModell> {
        otpSmsSendtTil: string;
    }

    /** @deprecated, bruk OppdaterGruppeSpesifikasjon @todo finner ikke java-ekvivalenten...*/
    export interface GruppeSpesifikasjon {
        id: string;
        tittel: string
        avtalenavn: string;
        moetenavn: string;
    }

    export interface GruppeAggreatModell {
        gruppeId: string;
        antallMoeter: number;
        antallMoeterAvholdt: number;
        antallSaker: number;
        antallDokumenter: number;
        antallOppgaver: number;
        antallOppgaverForfalt: number;
        antallOppgaverIkkeForfalt: number;
        antallOppgaverUtenFrist: number;
        antallOppgaverUtfoert: number;
        antallBeslutninger: number;
        antallMedlemmer: number;
        antallKommentarer: number;
        antallSvar: number;
    }

    export interface GrupperAggreatModell extends AngularRessurs<GrupperAggreatModell> {
        grupper: GruppeAggreatModell[];
    }

    export interface GeneriskPushModell {
        endretEntitet: l.EntitetReferanseModell;
        foreldre: l.EntitetReferanseModell[];
    }

    export interface OppdaterGruppeSpesifikasjon {
        id: string;
        tittel: string
        organisasjonsnavn: string
        moetenavn: string;
        logoBase64?: string;
        gruppetype?: Gruppetype; //mobil-appen sender ikke med gruppetype
        gruppemal?: OppdaterGruppemalSpesifikasjon //kun for malgrupper, mobil-appen sender aldri med gruppemal
    }

    export interface OppdaterGruppemalSpesifikasjon {
        navn: string;
        beskrivelse: string;
    }

    export interface GruppeMedlemListeModell extends EntitetModell<GruppeMedlemListeModell> {
        gruppeId: string;
        brukerId: string | null;
        navn: string;
        epost: string;
        mobilnummer: string | null;
        spraak: string | null;
        tidssone: string | null;
        /** @deprecated */ rolle: MedlemsRolleModell | null;
        /** @deprecated */ roller: MedlemsRollePeriodeModell[];
        aktiveMedlemsroller: MedlemsRollePeriode2Modell[];
        inaktiveMedlemsroller: MedlemsRollePeriode2Modell[];
        tilgangsroller: TilgangsrolleMedlem[];
        avatarId: string | null;
        /** @deprecated */ status: Invitasjonsstatus;
        invitasjonsstatus: Invitasjonsstatus;
        harTilgang: boolean;
        anonymisert: boolean;
        medlemstatus: Medlemstatus;
        medlemstatusSistEndret: Date;
    }

    export interface EnkelGruppeMedlemModell extends AngularRessurs<EnkelGruppeMedlemModell> {
        id: string;
        navn: string;
        harTilgang: boolean;
        anonymisert: boolean;
        medlemstatus: Medlemstatus;
    }

    export interface GruppeInvitasjonModell extends EntitetModell<GruppeInvitasjonModell> {
        epost: string;
        navn: string | null;
        navnEllerEpost: string;
        mobilnummer: string | null;
        avatarId: string | null;
        status: Invitasjonsstatus;
        opprettetDato: Date;
        rolle: MedlemsRollePeriodeModell;
        tilgangsroller: TilgangsrolleMedlem[];
    }

    export interface MøtevurderingerModell {
        moeteId: string;
        moetestart: Date;
        moetenummer: string;
        vurderinger: number[];
        snittvurdering: number;
    }

    export interface RedigerSakKontekst {
        tilgjengeligeAnsvarlige: GruppeMedlemListeModell[];
        forsteSakstype: SakstypeModell;
    }

    export interface MedlemsRolleModell extends EntitetModell<MedlemsRolleModell> {
        tittel: string;
        indeks: number;
        kanIkkeSlettes: boolean;
    }

    export interface MedlemsRolleSpesifikasjon {
        id: string;
        tittel: string;
    }

    export interface EntitetIdRespons extends AngularRessurs<EntitetIdRespons> {
        id: string;
    }

    export interface MøteIdOgSakId extends AngularRessurs<MøteIdOgSakId> {
        moeteId: string;
        sakId: string;
    }

    export interface AutentiseringsmetodeOppgraderingModell extends AngularRessurs<AutentiseringsmetodeOppgraderingModell> {
        kreverOppgarderingTilAutentiseringsmetode: Autentiseringsmetode[];
    }

    export interface ValiderTokenModell extends AngularRessurs<ValiderTokenModell> {
        erGyldig: boolean;
        tokeninfo: JwtTokenInfoModell;
    }

    export interface AutentisertOkModell extends AngularRessurs<AutentisertOkModell> {
        bruker: BrukerModell;
        brukervalg: Brukervalg;
        featurevalg: Featurevalg;
        tilgjengeligeGrupper: TilgjengeligGruppeModell[];
        grupperSomKreverAnnenAutentiseringsmetode: GruppeSomKreverAnnenAutentiseringsmetodeModell[];
        invitasjonerTilGodkjenning: GruppeInvitasjonTilGodkjenningModell[];
        kontaktpersonForAvtaler: AvtaleModell[];
        jwtTokenInfo: JwtTokenInfoModell;
    }

    export interface JwtTokenInfoModell {
        id: string;
        utloepstidspunkt: Date;
        utstedelsestidspunkt: Date;
        tokenvarighet: Tokenvarighet;
        autentiseringsmetode: BenyttetAutentiseringsmetode;
        tidTilUtloeper: number; //millisekunder
    }

    export interface AutentiseringResponsModell extends AngularRessurs<AutentiseringResponsModell> {
        status: AutentiseringStatus;
        error?: { kode: number, melding: string }
        autentisertBruker?: AutentisertOkModell;
        ukjentSubject?: SubjectIdIkkeKnyttetTilBrukerModell;
        kreverOppgarderingTilAutentiseringsmetoder?: Autentiseringsmetode[];
        otpSmsSendtTil?: string;
    }

    export interface CriiptoAutentiseringsResponsModell extends AngularRessurs<CriiptoAutentiseringsResponsModell> {
        lederplanRespons: AutentiseringResponsModell;
        styreplanRespons?: StyreplanLoginResponsModell;
        erBrukerILederplan: boolean;
        erBrukerIStyreplan: boolean;
    }

    export interface StyreplanLoginResponsModell {
        kryptertOpenIdIdentitet: string;
        styreplanLoginskjemaUrl: string;
    }

    export interface PassordResetResponsModell extends AngularRessurs<PassordResetResponsModell> {
        eksistererIBegge: boolean;
    }

    export interface KreverEidModell extends AngularRessurs<KreverEidModell> {
        kreverEid: boolean;
    }

    export interface FornyTokenModell extends AngularRessurs<FornyTokenModell> {
        bruker: EnkelBrukerModell;
        brukervalg: Brukervalg;
        featurevalg: Featurevalg;
        tilgjengeligeGrupper: TilgjengeligGruppeModell[];
        kontaktpersonForAvtaler: AvtaleModell[];
        jwtToken: string;
    }

    export interface TilgjengeligGruppeModell {
        gruppe: EnkelGruppeModell;
        aktiveMedlemmer: GruppeMedlemListeModell[];
        medlemskap: GruppeMedlemListeModell;
    }

    export interface GruppeSomKreverAnnenAutentiseringsmetodeModell {
        gruppe: EnkelGruppeModell;
        tillatteMetoder: Autentiseringsmetode[];
    }

    export interface IntroJsValg {
        avspilte?: {};
    }

    export interface Brukervalg {
        dashboardfane?: string;
        dashboardfilter?: DashboardFiltervalg;
        dashboardEkspanderteGrupper?: string[];
        introduksjoner?: IntroJsValg;
        detteErNyttSisteSett?: string;
    }

    export interface SubjectIdIkkeKnyttetTilBrukerModell extends AngularRessurs<SubjectIdIkkeKnyttetTilBrukerModell> {
        kryptertOpenIdIdentitet: string;
        openIdNavn: string;
        autentiseringsmetode: l.BenyttetAutentiseringsmetode;
        tokenvarighet: l.Tokenvarighet;
    }

    export interface DashboardFiltervalg {
        /** gruppeIder for valgte grupper */
        gruppeIder: string[];
        /** valgt periode, merk at vi forutsetter at dato er angitt i UTC-tid,
         * dvs start=01.01.YYYY 00:00:00:000Z og ikke i lokal tid 01.01.YYYY 00:00:00:000+01
         * - som ville blitt 31.12.YYYY 23:00:00:000Z i foregående år når omgjort til UTC*/
        periode: DatoPeriode;

        gruppering: SaksgrupperingPlan;
        visningsvalg: 'saksnummer' | 'saksnavn';
        visSaksdetaljer: boolean;
        visAarshjulinnslag: boolean;
    }

    export enum SaksgrupperingPlan {
        tema = 'tema', sakstype = 'sakstype', ansvarlig = 'ansvarlig'
    }

    export interface Featurevalg {
    }

    export interface GruppeMedlemModell extends EntitetModell<GruppeMedlemModell> {
        gruppeId: string;
        brukerId: string | null;
        navn: string;
        epost: string;
        mobilnummer: string | null;
        spraak: string | null;
        tidssone: string | null;
        /** @deprecated */ rolle: MedlemsRolleModell | null;
        /** @deprecated */ roller: MedlemsRollePeriodeModell[];
        aktiveMedlemsroller: MedlemsRollePeriode2Modell[];
        inaktiveMedlemsroller: MedlemsRollePeriode2Modell[];
        tilgangsroller: TilgangsrolleMedlem[];
        avatarId: string | null;
        /** @deprecated */ status: Invitasjonsstatus;
        invitasjonsstatus: Invitasjonsstatus;
        harTilgang: boolean;
        anonymisert: boolean;
        medlemstatus: Medlemstatus;
        medlemstatusSistEndret: Date;
        gruppe: EnkelGruppeModell;
    }

    export interface MedlemsRollePeriodeModell {
        id: string;
        medlemsrolleId: string;
        tittel: string;
        indeks: number;
        periode: DatoPeriode;
    }

    export interface MedlemsRollePeriode2Modell {
        id: string;
        medlemsrolleId: string;
        tittel: string;
        indeks: number;
        periode: DatoPeriodeUtenTid;
    }

    export interface DatoPeriodeUtenTid {
        //per nå støtter ikke ajs-implementasjonen temporal-apiet, java-sidens LocalDate blir derfor representert som string
        slutt: string | null;
        start: string;
    }

    export interface InvitasjonSlettetRespons extends AngularRessurs<InvitasjonSlettetRespons> {
        slettet: boolean;
        anonymisertInvitasjon?: GruppeMedlemModell;
    }

    export interface MedlemAssosiasjonerModell extends AngularRessurs<MedlemAssosiasjonerModell> {
        antTilknyttetMoeteSomArrangoer: number;
        antTilknyttetAvholdtEllerLaastMoeteSomDeltaker: number;
        antTilknyttetFremtidigIkkelaastMoeteSomDeltaker: number;
        antTilknyttetAvholdtEllerLaastProtokollSomDeltaker: number;
        antTilknyttetFremtidigIkkelaastProtokollSomDeltaker: number;
        antTilknyttetAvholdtEllerLaastSakSomAnsvarlig: number;
        antTilknyttetFremtidigIkkelaastSakSomAnsvarlig: number;
        antTilknyttetOppgaverSomAnsvarlig: number;
        antTilknyttetKommentarerSomForfatter: number;
        antTilknyttetDokument: number;
        antTilknyttetDokumentSomSignatarSomIkkeHarSignert: number;
        erTilknyttetMalmoete: boolean;
    }

    export interface KanSlettesModell extends AngularRessurs<KanSlettesModell> {
        kanSlettes: boolean;
        antallOppgaverSomAnsvarlig: number;
        antallKommentarerSomForfatter: number;
    }

    /** @deprecated, bruk OppdaterMedlemSpesifikasjon */
    export interface OppdaterMedlemModell {
        id: string;
        rolle: MedlemsRolleModell;
        harTilgang: boolean;
    }

    export interface OppdaterMedlemSpesifikasjon {
        id: string;
        /** @deprecated*/ rolleId?: string; //brukes fortsatt i mobil
        nyeMedlemsrolleperioder?: NyRolleSpesifikasjon[]; //mobil bruker rolleId
        oppdaterteMedlemsrolleperioder?: RedigerRolleSpesifikasjon[]; //mobil bruker rolleId
        tilgangsroller: TilgangsrolleMedlem[];
    }

    export interface RedigerRolleSpesifikasjon {
        id: string;
        slettet: boolean;
        start: Date;
        slutt: Date | null;
    }

    export interface NyRolleSpesifikasjon {
        id: string;
        rolleId: string;
        start: Date;
        slutt: Date | null;
    }

    export interface OppdaterMedlemTilgangSpesifikasjon {
        id: string;
        harTilgang: boolean;
    }

    export interface MedlemÅpneTilgangSpesifikasjon {
        oppdaterMoetemal: boolean;
        oppdaterFremtidigeMoeter: boolean;
        skalSignereSomStandard: boolean;
    }

    export interface MedlemStengTilgangSpesifikasjon {
        oppdaterMoetemal: boolean;
        oppdaterFremtidigeMoeter: boolean;
        avsluttedeRolleperioder: AvsluttRolleperiodeSpesifikasjon[];
    }

    export interface AvsluttRolleperiodeSpesifikasjon {
        id: string;
        slutt: Date | null;
    }

    export interface MedlemsRolleIGruppeModell {
        rolle: MedlemsRolleModell;
        gruppe: EnkelGruppeModell;
    }

    export interface NyttPassordFraTokenModell {
        token: string;
        passord: string;
    }

    export interface NyttPassordModell {
        eksisterendePassord: string;
        nyttPassord: string;
    }

    export interface PassordValideringsresultat extends AngularRessurs<PassordValideringsresultat> {
        gyldig: boolean;
        feilkoder: string[];
    }

    export interface BrukernavnValideringsresultat extends AngularRessurs<BrukernavnValideringsresultat> {
        gyldig: boolean;
        feilkoder: string[]
    }

    export interface BekreftEpostadresseSendtModell extends AngularRessurs<BekreftEpostadresseSendtModell> {
        epostadresse: string;
        meldingstittel: string;
        sendt: boolean;
    }

    export interface BekreftMobilnummerOtpSendtModell extends AngularRessurs<BekreftMobilnummerOtpSendtModell> {
        otpSendtTil: string;
        sendt: boolean;
    }

    export interface ValideringResponsModell extends AngularRessurs<ValideringResponsModell> {
        validert: boolean;
    }

    export interface TotpReservekoderModell extends AngularRessurs<TotpReservekoderModell> {
        autentiseringOk: boolean;
        reservekoder: { [reservekode: string]: boolean } | null;
    }

    export interface SmsOtpReservekoderModell extends AngularRessurs<SmsOtpReservekoderModell> {
        autentiseringOk: boolean;
        reservekoder: { [reservekode: string]: boolean } | null;
    }

    export interface OtpDeaktivertModell extends AngularRessurs<OtpDeaktivertModell> {
        autentiseringOk: boolean;
    }

    export interface HendelseAggregat extends AngularRessurs<HendelseAggregat> {
        entitetType: string;
        endringstype: Endringstype;
        subEndringstype: SubEndringstype;
        antall: number;
    }

    export interface EndringshendelseModell extends EntitetModell<EndringshendelseModell> {
        gruppeId: string;
        entitetReferanse: EntitetReferanseModell;
        endringstype: Endringstype;
        subEndringstype: SubEndringstype;
        bruker: EnkelBrukerModell;
        utfoertDato: Date;
        beskrivelse: StrengMalEndringshendelse<any>;
        foreldre: EntitetReferanseModell[];
    }

    export interface StrengMalEndringshendelse<T> extends StrengMal<EndringshendelseBeskrivelse<T>> {
    }

    export interface EndringshendelseBeskrivelse<T> {
        beskrivelse: T;
        feltendringer: { [felt: string]: FeltendringModell };
    }

    export interface FeltendringModell {
        gammelVerdi: any;
        nyVerdi: any;
        felt: string;
    }

    export interface Modelloppdatering {
        /** identifiserer klienten (nettleservinduet) som forårsaket modelloppdateringen. Se {@link Konfigurasjon#klientId}*/
        klientId?: string | null;
        /** http respons status */
        status: number;
        /** angir typen oppdatering, se konstanter definert i Modelloppdatering.ts */
        type: string;
        modell: any;
    }

    export interface GruppeInvitasjonSpesifikasjoner {
        gruppeId: string;
        invitasjoner: OpprettGruppeInvitasjonSpesifikasjon[];
    }

    export interface OpprettGruppeInvitasjonSpesifikasjon {
        gruppeId: string;
        navn: string;
        epost: string;
        mobilnummer: string;
        rolleId: string;
        rolleStartdato?: Date; //ikke med i mobil-klienten
        avatar: string;//sti til fil
        tilgangsroller: TilgangsrolleMedlem[];
        oppdaterMoetemal?: boolean; //ikke med i mobil-klienten
        skalSignereSomStandard?: boolean; //ikke med i mobil-klienten
        oppdaterFremtidigeMoeter?: boolean; //ikke med i mobil-klienten
        sendInvitasjon?: boolean; //ikke med i mobil-klienten
    }

    export interface InitBankIDModell extends AngularRessurs<InitBankIDModell> {
        sesjonsid: string;
        helperURI: string;
        traceId: string;
        clientId: string;
        brukerMedEksisterendeSesjon: l.EnkelBrukerModell;
        signert: boolean;
        feilkode: string;
    }

    export interface ArkivnodeModell<T> extends EntitetModell<T> {
        navn: string;
        forelder: ArkivMappenodeModell;
        erMappe: boolean;
        erRotMappe: boolean;
        eiendeGruppeId: string;
    }

    export interface ArkivMappenodeModell extends ArkivnodeModell<ArkivMappenodeModell> {
        beskrivelse: string;
        barn: ArkivnodeModell<any>[];
        skjerming: SkjermingModell;
    }

    export interface ArkivFilnodeModell extends ArkivnodeModell<ArkivFilnodeModell> {
        dokument: ArkivdokumentModell;
    }

    export interface ArkivdokumentModell extends DokumentVersjonBasisModell<ArkivdokumentModell> {

    }

    export interface ImportresultatModell {
        rotmappe: ArkivMappenodeModell;
        importerteFiler: String[];
        filerSomAlleredeEksisterte: String[];
        filerSomBleIgnorert: String[];
        filerSomVarForStore: String[];
    }

    export interface DokumentVersjonOgSakerModell {
        dokumentVersjon: DokumentVersjonModell;
        tilknyttedeSaker: TynnSakModell[];
    }

    export interface NyMappeSpesifikasjon {
        forelder: string;
        navn: string;
        beskrivelse: string;
    }

    export interface OppdaterMappeSpesifikasjon {
        navn: string;
        beskrivelse: string;
    }

    export interface InitierTotpQrkodeModell extends AngularRessurs<InitierTotpQrkodeModell> {
        qrKodeBilde: string;
    }

    export interface TotpOppsettBekreftetModell extends AngularRessurs<TotpOppsettBekreftetModell> {
        verifisert: boolean;
        reservekoder: { [reservekode: string]: boolean } | null;
    }

    export interface AuthorizeUrlModell extends AngularRessurs<AuthorizeUrlModell> {
        criiptoAuthorizeUrl: string;
    }

    export interface SignUrlModell extends AngularRessurs<SignUrlModell> {
        criiptoSignUrl: string;
        bankidSigneringOrdre: BankidSigneringOrdreModell;
    }

    export interface BankidSigneringOrdreModell {
        signId: string;
        signUrl: string;
    }

    export interface BankidSigneringStatusModell extends AngularRessurs<BankidSigneringStatusModell> {
        signeringId: string;
        status: BankIdSigneringStatus;
    }

    export enum BankIdSigneringStatus {
        ordre_mottatt = 'ordre_mottatt',
        bruker_signerer = 'bruker_signerer',
        avvist = 'avvist',
        feilet = 'feilet',
        utlopt = 'utlopt',
        signering_fullfort = 'signering_fullfort',
        UKJENT = 'UKJENT',
    }


    export interface SigneringOtpSendtModell extends AngularRessurs<SigneringOtpSendtModell> {
        otpSendtTil: string;
        sendt: boolean;
        autentiseringOk: boolean;
    }

    export interface OtpSigneringValideringResponsModell extends AngularRessurs<OtpSigneringValideringResponsModell> {
        validert: boolean;
    }

    export interface SendSmsOtpSigneringSpesifikasjon {
        mobilnummer?: string;
        autentiseringsinfo?: Reautentiseringsinformasjon;
    }

    export interface MigreringStatusModell extends EntitetModell<MigreringStatusModell> {
        status: string;
        tidBrukt: string;
        alleMeldinger: MigreringLoggmelding[];
        detaljMeldinger: String[];
        infoMeldinger: String[];
        sp2TilSp3Mappinger: Sp2TilSp3Mapping[];
        feilliste: Feil[];
        sisteException: string;
    }

    export interface MigreringLoggmelding {
        tid: string;
        type: string;
        melding: string;
    }

    export interface Sp2TilSp3Mapping {
        sp2Id: number;
        sp2Tabell: string;
        sp3Entitet: l.EntitetReferanseModell;
        tillegsinfo: string;
    }

    export interface Feil {
        key: string;
        spOrgid: number;
        feilMelding: string;
        tabellMedFeil: string;// feks meeting
        idMedFeil: number; // feks meeting.serial
    }

    export interface SystemMeldingModell extends EntitetModell<SystemMeldingModell> {
        melding: string;
        meldingstype: Meldingstype;
        varseltype: Varseltype;
        gyldigTil: Date;
    }

    export interface OpprettSystemMeldingSpesifikasjon {
        melding: string;
        meldingstype: Meldingstype;
        varseltype: Varseltype;
        varighetIMinutter: number;
    }

    export interface TilgangModell {
        erMoetePublisert: boolean;
        erProtokollPublisert: boolean;
        skjerming: SkjermingModell;
    }

    export interface SkjermingModell {
        erSkjermetForKallendeBruker: boolean;
        inneholderSkjermedeBarn: boolean;
        inneholderBarnSkjermetForKallendeBruker: boolean;
        skjermedeMedlemmerId: string[];
        aarsak: string;
    }

    export interface SkjermingDetaljerModell extends SkjermingModell, AngularRessurs<SkjermingDetaljerModell> {
        harSkjermetForelderForKallendeBruker: boolean;
        medlemmerIdUtenTilgangTilForelder: string[];
        medlemmerUtenTilgang: GruppeMedlemListeModell[];
        aarsak: string;
    }

    export interface OppdaterSkjermingSpesifikasjon {
        medlemmerUtenTilgang: string[];
        aarsak: string;
    }

    export interface OpprettSkjemalåsSpesifikasjon {
        eiendeGruppeId: string;
        rotentitetId: EntitetReferanseSpesifikasjon;
        skjemaId: SkjemalåsSkjemaId;
        skjema: string;
        klientId: string;
        overtaEksisterendeLaas: boolean;
    }

    export interface OppdaterSkjemalåsSpesifikasjon {
        id: string;
        skjema: string;
        klientId: string;
    }

    //@todo bør vi ha med en skjema-versjonsnummer variable som kan brukes for å identifiserer tilfeller der feltdefinisjonene i spesifikasjonen/skjema har blitt endret?
    export interface SkjemalåsModell extends EntitetModell<SkjemalåsModell> {
        eiendeGruppeId: string;
        rotentitetId: EntitetReferanseModell;
        skjemaId: SkjemalåsSkjemaId;
        initieltSkjema: string;
        skjema: string;
        oppdatertDato: Date;
        opprettetDato: Date;
        eier: EnkelGruppeMedlemModell;
        klientId: string;
    }

    export interface OpprettSkjemalåsResponsModell extends AngularRessurs<OpprettSkjemalåsResponsModell> {
        ervervetLaas: SkjemalåsModell;
        laasIKonflikt: SkjemalåsModell;
        status: OpprettSkjemalåsStatus;
    }

    export enum OpprettSkjemalåsStatus {
        låsOpprettet = 'låsOpprettet',
        låstAvAnnenBruker = 'låstAvAnnenBruker',
        låstAvSammeBrukerAnnetVindu = 'låstAvSammeBrukerAnnetVindu',
        ingenEndringerLåsOvertatt = 'ingenEndringerLåsOvertatt'
    }

    export interface OppdaterSkjemalåsResponsModell extends AngularRessurs<OppdaterSkjemalåsResponsModell> {
        oppdatertLaas: SkjemalåsModell;
        laasIKonflikt: SkjemalåsModell;
        status: OppdaterSkjemalåsStatus;
    }

    export enum OppdaterSkjemalåsStatus {
        låsOppdatert = 'låsOppdatert',
        låstAvAnnenBruker = 'låstAvAnnenBruker',
        låstAvSammeBrukerAnnetVindu = 'låstAvSammeBrukerAnnetVindu',
    }

    //ES søkeresultatelementer
    export namespace es {
        export interface Bucket {
            key: string;
            doc_count: number;
        }
    }

    export enum AsynkOppgaveStatus {
        // NB må holdes i synk med backend
        ikke_pabegynt = 0,
        pabegynt = 1,
        feilet = 2,
        avsluttet = 3,
        parkert = 4,
    }

    export interface AsynkOppgaveModell {
        id: string;
        status: AsynkOppgaveStatus;
        statusSistEndretDato: Date;
        type: string;
        konfigurasjon: Map<string, string>;
        kanRestartes: boolean;
        kanParkeres: boolean;
    }

    export interface AksjeeierbokModell extends EntitetModell<AksjeeierbokModell> {
        totalBeholdning: number;
        aksjeeiere: AksjeeierEnkelModell[];
        aksjeklasser: AksjeklasseModell[];
    }

    export interface AksjeeierModell extends AksjeeierEnkelModell {
        beholdningshistorikk: AksjeeierBeholdningModell[];
    }

    export interface AksjeeierEnkelModell extends EntitetModell<AksjeeierEnkelModell> {
        aksjeeierbokId: string;
        type: Aksjeeiertype;
        navn: string;
        epost?: string;
        adresse: string;
        organisasjonsnummer?: string;
        foedselsdato?: string; /*Temporal.PlainDate*/
        totalBeholdning: number;
        naavaerendeBeholdning?: AksjeeierBeholdningModell;
        representertAv?: EnkelGruppeMedlemModell;
    }

    export interface AksjeeierBeholdningModell extends EntitetModell<AksjeeierBeholdningModell> {
        aksjenummer: string;
        antall: number;
        eierandel: string;
        aksjeklasse?: AksjeklasseModell;
        gyldigFraTil: { start: string /*Temporal.PlainDate*/, slutt: string; /*Temporal.PlainDate*/ };
        kommentar?: string;
    }

    export interface AksjeklasseModell extends EntitetModell<AksjeklasseModell> {
        navn: string;
        beskrivelse: string;
    }

    export interface SendEpostResultatModell extends AngularRessurs<SendEpostResultatModell> {
        sendt: string[]; // medlemsId/brukerId
        ikkeSendt: string[]; // medlemsId/brukerId
    }

    export interface SpørreskjemaModell {
        id: string;
        tittel: string;
        beskrivelse: string;
        spoersmaal: SpørsmålModell[];
    }

    export interface SpørsmålModell {
        id: string;
        tittel: string;
        beskrivelse: string;
        type: Spørsmålstype;
        oppsett: SpørsmålOppsett;
    }

    export interface SpørreundersøkelseEnkelModell {
        id: string;
        eiendeGruppeId: string;
        tittel: string;
        responsperiode: DatoPeriode;
        responsperiodeAntallDager: number | null;
        erAapenForRespons: boolean;
        erAvsluttet: boolean;
        /**
         * Antall gruppemedlemmer registrert som respondenter
         */
        antallRespondenter: number;
        /**
         * Antall gruppemedlemmer som har besvart undersøkelsen
         */
        antallRespondenterSvart: number;
        kallendeBrukersRespondentId: string | null;
        skjemaId: string;
        skjemaTittel: string;
    }

    export interface SpørreundersøkelseEnkelMedBehandlingerModell extends SpørreundersøkelseEnkelModell {
        behandlinger: TynnSakModell[];
    }

    export interface SpørreundersøkelseModell extends SpørreundersøkelseEnkelModell {
        skjema: SpørreskjemaModell;
        respondenter: GruppeMedlemListeModell[];
    }

    export interface KorellertGruppertSpørreundersøkelseResultatModell {
        primaerUndersoekelse: SpørreundersøkelseEnkelModell;
        sekundaereUndersoekelser: SpørreundersøkelseEnkelModell[];
        grupper: SpørsmålsgruppeMedResultaterModell[];
    }

    export interface SpørsmålsgruppeMedResultaterModell {
        gruppe: SpørsmålOgResultaterModell;
        spoersmaalsamling: SpørsmålOgResultaterModell[];
        alleSpoersmaalErAvSammeTypeOgOppsett: boolean;
        spoersmaalstype: Spørsmålstype | null;
        spoersmaalsoppsett: SpørsmålOppsett | null;
    }

    export interface RespondentBesvarelseModell {
        /**
         * Map med innslag av typen SpørsmålId -> svar
         */
        besvarelser: { [index: string]: string };
    }

    export type RespondentId = string;

    export interface OppsummertTranskribertMøtereferatModell {
        saker: OppsummertTranskribertSaksreferatModell[];
    }

    export interface OppsummertTranskribertSaksreferatModell {
        sakId: string | null;
        tittel: string;
        oppsummering: string;
        beslutninger: BeslutningITranskribertSaksreferatModell[];
    }

    export interface BeslutningITranskribertSaksreferatModell {
        tittel: string;
        beskrivelse: string;
        oppgaver: OppgaveITranskribertSaksreferatModell[];
    }

    export interface OppgaveITranskribertSaksreferatModell {
        tittel: string;
        beskrivelse: string;
        ansvarlig: GruppeMedlemListeModell | null;
        frist: string | null;
    }

}
